module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1238.b831bc51.png";